// extracted by mini-css-extract-plugin
export var chip = "_b0-0";
export var filterDropdown = "_b0-5";
export var filterItem = "_b0-6";
export var icon = "_b0-1";
export var removeButton = "_b0-3";
export var removeIcon = "_b0-4";
export var separator = "_b0-2";